import styled, { css } from 'styled-components'

export const SideBarContainer = styled.div`
  z-index: 999;  
  height: 100%;
  background: #222430;
  backdrop-filter: blur(40px);
  border-radius: 15px;
  overflow: hidden;
`

export const ExpandHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 30px 20px;

  > span {
    position: absolute;
    left: 20px;
    cursor: pointer;

    &:hover svg {
      transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      transform: scale(1.07);
    }
  }
`

export const ReduceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
  cursor: pointer;
  transition: all cubic-bezier(0.215, 0.610, 0.355, 1);
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  &:hover {
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
    background: #262835;

    svg {
      transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      transform: scale(1.07);
    }
  }
`

export const FilterTitleWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
    color: white;
  }
`

export const FilterContainer = styled.div`
  overflow: auto;
  display: none;
  /* border-radius: 15px; */
  max-height: calc(100% - 80px);

  ${({ active }) => active && css`
    display: block;
  `}
`
